import React, { Component, createRef, Fragment } from "react";
import {
  Hero,
  Title,
  TechniqueTitle,
  ClientTag,
  CaseWrapper,
  BackButton,
  BackArrow
} from "../styles/Case.styles";

import Reveal from 'react-reveal/Reveal';
import { withRouter } from "react-router";
import Footer from '../components/Footer';
import { Efectr, Efectr1, Efectr2  } from "../styles/effect.styles";

export const ScrollTop = ({ children, location }) => {
  React.useEffect(() => window.scrollTo(0, 0), [location])
  return children
}

class Case extends Component {
  constructor(props) {
    super(props);
    this.introRef = createRef();

    this.state = {
          toBack: false,
          introTop: 0,
          hasBackground: false,
          animateCase: ""
        };
      }
    
      componentDidUpdate() {
        if (this.state.toBack) {
          setTimeout(() => {
            this.props.setNavBackground(false);
            this.props.history.push("/blog");
          }, 400);
        }
        if (this.state.animateCase) {
          setTimeout(() => {
            this.props.setNavBackground(false);
    
            this.props.history.push(this.state.animateCase);
            window.scrollTo(0, 0);
          }, 400);
        }
      }
    
    
      render() {
        return (
          <Fragment>
          <Efectr/>
          <Efectr1/>
          <Efectr2/>
          <ScrollTop>
            <CaseWrapper>
              <Reveal effect="fadeIn">
                <Hero className='mainhero' style={{ backgroundImage: "url('./img/news/AllLrg.png')" }}>
                    <div className='herocaption'>
                      <BackButton className='backdetail'
                        onClick={() => this.setState({ toBack: true, hasBackground: false })}
                        toBack={this.state.toBack}
                        hasBackground={this.state.hasBackground}>
                        <BackArrow src="./img/back.png" alt="Back to blog" />
                        <span>Back </span>
                      </BackButton>
                      <div className='container'>
                        <div className='row'>
                          <div className='col-md-12 pl-md-0'>
                            <ClientTag className='date'>June 10, 2024</ClientTag>
                            <Title>Electrolytes: Stay Current!</Title>
                            <TechniqueTitle>
                            Why Electrolytes will keep you Charged Up this Summer
                            </TechniqueTitle>
                          </div>
                        </div>
                      </div>
                    </div>
                </Hero>
              </Reveal>
    
              <section className='container' id='detailproject'>
                <div className='row'>
                  <div className='col-md-12'>
                    <p className='content'>Electrolytes, the charged minerals coursing through our bodies, are a vital component of our physiological balance. Among these essential electrolytes are sodium, potassium, calcium, magnesium, chloride, bicarbonate, and phosphate. Their presence is not merely incidental; rather, they play pivotal roles in sustaining our bodily functions.</p>
                    <p className='content'>
                    During the summer months, the significance of electrolytes becomes even more pronounced. They maintain optimal hydration levels by orchestrating fluid equilibrium within our system. Particularly crucial during bouts of elevated temperatures and physical exertion, electrolytes are instrumental in preserving muscle integrity and staving off debilitating cramps. </p>
                     <p className='content'>Beyond hydration, electrolytes also influence our neural pathways, ensuring smooth transmission of signals. Moreover, they are the unsung heroes behind our body's ability to thermoregulate, facilitating the cooling mechanism of perspiration. </p>
                     <p className='content'>However, the misconception that rehydration solely requires water can lead to precarious imbalances, notably in sodium levels, resulting in a condition known as hyponatremia. Symptoms ranging from headaches to muscle cramps indicate this
                     electrolyte disruption, with severe cases potentially causing brain swelling, seizures, and comas. </p>
                     <p className='content'>By incorporating electrolyte-rich solutions into our hydration strategies, we safeguard against the perils of electrolyte imbalances, ensuring a summer season characterized by both vitality and enjoyment.</p>

                  
                    <h3 className='my-5'>How to Incorporate Electrolytes</h3>
                    <div>
                      <p className='content'>1. Fruits & Salt: Citrus fruits, berries, ginger, mint, and salt can provide natural electrolytes into the water that you drink </p>
                      <p className='content'> 2. Supplements: Different brands of electrolyte mixes can be added to water to add both flavour and beneficial electrolytes </p>
                      <p className='content'>3. Expert help: Speak with your naturopathic doctor to learn more about which electrolytes and when to supplement correctly! </p>
                    </div>
                  </div>  

                  <div className='col-md-12'></div>
                  <div className='share'>
                    <span className='heading'>
                    Share this blog post :
                    </span>
                    <span className='content'> 
                    <a href="https://www.facebook.com/sharer/sharer.php?u=drmichellemaliknd.com/WOW7" target="_blank" rel="noopener noreferrer">  
                      <i className="fa fa-facebook-f"></i>
                      </a>  
                    </span>
                    <span className='content'> 
                    <a href="https://www.instagram.com/dr.michellemalik.nd" target="_blank" rel="noopener noreferrer">   
                      <i className="fa  fa-instagram"></i>
                      </a>
                    </span>
                  </div>
                </div>
              </section>

            </CaseWrapper>

                      </ScrollTop>
                
                      <Footer />
                
                      </Fragment>
                    );
                  }
                }
                
                export default withRouter(Case);